import React, { useRef } from "react";
import { STAGE_ELEMENT } from "../../../../constants";
import { StageElement as StageElementType } from "../../../../types";
import { getStageElementClassName } from "./stageElementClassNames";
import { RceStageElement, ConstrainedHeight, ParallaxWrapper } from "./styles";

interface StageElementWrapperProps {
  element: StageElementType;
  elementIndex: string;
  elementsPadding?: { vertical?: number; horizontal?: number };
  children: React.ReactNode;
}

export const StageElementWrapper: React.FC<StageElementWrapperProps> = ({
  element,
  elementsPadding,
  children,
}) => {
  const stageElementRef = useRef<HTMLDivElement>(null);

  const elementHeight =
    element.type === STAGE_ELEMENT.IMAGE ? "auto" : (element.config as any)?.height;

  return (
    <div ref={stageElementRef}>
      <RceStageElement
        className={getStageElementClassName(element.type)}
        elementsPadding={elementsPadding}
        isGrabbable={false}
        elementRef={element.ref}
        data-id={element.ref}
      >
        <ParallaxWrapper className="spf-parallax-wrapper" {...(element.config?.parallax as object)}>
          <ConstrainedHeight height={elementHeight}>{children}</ConstrainedHeight>
        </ParallaxWrapper>
      </RceStageElement>
    </div>
  );
};
